import { TooltipContentModule, TooltipContext } from "./tooltip-types";
import { CustomTooltip } from "src/components/CustomTooltip";
import styles from "./Tooltip.module.css";
import { UserAvatar } from "src/components/UserAvatar";
import { attributeToTitle } from "src/utils/strings";

export const UserTooltipModule: TooltipContentModule = {
  type: "entity",
  priority: 2,
  shouldRender: (context: TooltipContext) => {
    return context.type === "entity" && context.field?.target === "User";
  },
  render: (context: TooltipContext) => {
    const { field, metadata, formattedValue, record } = context;
    if (!field?.target) return context.children;

    const userData = record || metadata;
    const userName = userData?.name || formattedValue;
    const avatarUrl = userData?.avatarUrl;
    const email = userData?.email;

    const content = (
      <div className={styles.tooltip_container}>
        <div className={styles.tooltip_header}>User Information</div>
        <div className={styles.tooltip_section}>
          <div className={styles.tooltip_section_row}>
            <UserAvatar
              size="medium"
              user={{
                name: userName,
                avatarUrl: avatarUrl,
                uuid: userData?.uuid,
              }}
              style={{ marginRight: 12 }}
            />
          </div>
        </div>

        {Object.entries(metadata || {})
          .filter(([_, value]) => value !== null && value !== undefined)
          .map(([key, value]) => (
            <div key={key} className={styles.tooltip_row}>
              <div className={styles.tooltip_label}>
                {attributeToTitle(key)}
              </div>
              <span className={styles.tooltip_value}>{String(value)}</span>
            </div>
          ))}
      </div>
    );

    return (
      <CustomTooltip content={content} placement="right" size="medium">
        {context.children}
      </CustomTooltip>
    );
  },
};
